// @ts-nocheck
import * as React from 'react';
import moment from 'moment';
import { sectionActions } from 'ducks/section/actions';
import { useDispatch } from 'react-redux';
import Loader from 'components/uielements/Loader/index';
import CreateSection from './CreateSection';
import JoinSection from './JoinSection';
import type { SectionProps } from './Section.types';

const Section = ({
  courseSlug,
  unitId,
  moodleCourseId,
  onChangeHeaderTitle,
  onNextStep,
  onFinish,
  hasSections,
  isLoading,
  headerTitle,
  lms,
}: SectionProps): React.ReactElement<any> | null => {
  const [sectionType, setSectionType] = React.useState('join');
  const [dateSelected, setDateSelected] = React.useState(moment().format());
  const [initialLoading, setInitialLoading] = React.useState(true);
  const dispatch = useDispatch();
  const firstTimeIsLoadingRef = React.useRef(false);

  const getSectionsByDate = (date: string): void => {
    const dateFormatted = moment(date).format('YYYY-MM-DD');
    const numItems = 5;
    dispatch(
      sectionActions.getSectionsRequest({
        date: dateFormatted,
        unitId,
        numItems,
        moodleCourseId,
        lms,
      }),
    );
  };

  const setHeaderToCreate = (): void => {
    onChangeHeaderTitle('create');
  };

  React.useEffect(() => {
    getSectionsByDate(dateSelected);
  }, [dateSelected]);
  React.useEffect(() => {
    // Only the first time we sucessfully requested the sections we can be sure to hide the loader and show corresponding component and header
    if (!isLoading && firstTimeIsLoadingRef.current && initialLoading) {
      setInitialLoading(false);

      if (!hasSections) {
        setHeaderToCreate();
      }
    }

    if (isLoading) {
      firstTimeIsLoadingRef.current = true;
    }
  }, [isLoading, hasSections]);

  const handleChangeSection = (sectionName: string): void => {
    setSectionType(sectionName);
    onChangeHeaderTitle(sectionName);
  };

  const handleChangeDate = (newDate) => {
    const formatDate = moment(newDate).format('YYYY-MM-DD');
    setDateSelected(formatDate);
  };

  const handleCloseDatePicker = (): void => {
    if (dateSelected && sectionType === 'join') {
      getSectionsByDate(dateSelected);
    }
  };

  const renderSection = (): React.ReactElement<any> =>
    sectionType === 'join' && hasSections ? (
      <JoinSection
        headerTitle={headerTitle}
        onChangeHeaderTitle={() => onChangeHeaderTitle('join')}
        hasSections={hasSections}
        dateSelected={dateSelected}
        onChangeDate={handleChangeDate}
        courseSlug={courseSlug}
        onChangeSection={handleChangeSection}
        onNextStep={onNextStep}
        onFinish={onFinish}
        onClose={handleCloseDatePicker}
      />
    ) : (
      <CreateSection
        headerTitle={headerTitle}
        onChangeHeaderTitle={setHeaderToCreate}
        hasSections={hasSections}
        dateSelected={dateSelected}
        onChangeDate={handleChangeDate}
        unitId={unitId}
        moodleCourseId={moodleCourseId}
        courseSlug={courseSlug}
        onChangeSection={handleChangeSection}
        onNextStep={onNextStep}
        onFinish={onFinish}
      />
    );

  return initialLoading ? <Loader /> : renderSection();
};

export default Section;
